import {Overlay, ProgressBar, RootView, Screen, ScreenContainer, Spinner} from "@dp-instant/2d";
import {Types2D} from "@dp-instant/interfaces";
import {inject, injectable} from "inversify";
import {Graphics} from "pixi.js-legacy";

@injectable()
export default class Root extends RootView {
    @inject(Types2D.spinner)
    public readonly spinner: Spinner;

    @inject(Types2D.screenContainer)
    public readonly popupContainer: ScreenContainer;

    @inject(Types2D.screenContainer)
    public readonly screenContainer: ScreenContainer;

    @inject(Types2D.overlay)
    public readonly overlay: Overlay;

    @inject(ProgressBar)
    public readonly progressBar: ProgressBar;

    onAdded() {
        this.progressBar.init({width: 200, height: 7});
        this.progressBar.visible = false;
        this.overlay.addChild(new Graphics().beginFill(0xd0d0d0).drawRect(0, 0, 10, 10).endFill());
        this.addChild(this.screenContainer);
        this.addChild(this.popupContainer);
        this.addChild(this.overlay);
        this.addChild(this.spinner);
        this.addChild(this.progressBar);
        super.onAdded();
    }

    public async goToScreen(screen?: Screen, showAd = true) {
        // if (showAd) {
        //     await di.get<Action>(TypesAds.adAction).run();
        // }
        await this.screenContainer.setScreen(screen);
        await this.overlay.unblur();
    }

    public freeze() {
        // if (this.app.ticker.started) {
        //     this.app.ticker.stop();
        // }
    }

    public unfreeze() {
        // if (!this.app.ticker.started) {
        //     this.app.ticker.start();
        // }
    }

    protected onResize() {
        this.spinner.x = (this.size.width - this.spinner.width) * 0.5;
        this.spinner.y = (this.size.height - this.spinner.height) * 0.5;

        [this.overlay].forEach(view => {
            view.width = this.size.width;
            view.height = this.size.height;
        });

        this.progressBar.x = this.size.width * 0.5;
        this.progressBar.y = this.size.height * 0.75;

        [this.screenContainer, this.popupContainer].forEach(cont => {
            cont.size = this.size;
            cont.onResize();
        });
    }
}
